import {initializeModalControls, } from './modals-control'
import {comboOfferEbookSelected, claimComboOfferClicked } from './cart'
import {InitializeTabControls } from './collabo-offer'

// Dom and resources like images and iframes, are ready when load event fires
window.addEventListener('load', function() {
    // Get all modals and attach their event listeners
    // initializeModalControls()
})

// Maybe call this once dom is ready eventListener. Images we use are dataurl images
document.addEventListener("DOMContentLoaded", (_) => {

  // Get all modals and attach their event listeners
  initializeModalControls()

  // Initialize TabControls
  InitializeTabControls()

  // Other event listeners
  AttachOtherEventListeners()

});


/* Notice to Opera Mini Users */
// Detect Opera Mini
var isOperaMini = (navigator.userAgent.indexOf('Opera Mini') > -1);
// Check if Opera Mini is detected
if (isOperaMini) {
    // Display message to users
    alert("We've detected that you're using Opera Mini. Some features of this app may not work properly. For the best experience, we recommend using a different browser like Chrome or Firefox or Safari.");
}


/* Aside & Navbar: dropdowns */

Array.from(document.getElementsByClassName('dropdown')).forEach(elA => {
    elA.addEventListener('click', e => {
      if (e.currentTarget.classList.contains('navbar-item')) {
        e.currentTarget.classList.toggle('active')
      } else {
        const dropdownIcon = e.currentTarget.getElementsByClassName('mdi')[1]
  
        e.currentTarget.parentNode.classList.toggle('active')
        dropdownIcon.classList.toggle('mdi-plus')
        dropdownIcon.classList.toggle('mdi-minus')
      }
    })
})
  
  /* Aside Mobile toggle */
  
  Array.from(document.getElementsByClassName('mobile-aside-button')).forEach(el => {
    el.addEventListener('click', e => {
      const dropdownIcon = e.currentTarget
          .getElementsByClassName('icon')[0]
          .getElementsByClassName('mdi')[0]
  
      document.documentElement.classList.toggle('aside-mobile-expanded')
      dropdownIcon.classList.toggle('mdi-forwardburger')
      dropdownIcon.classList.toggle('mdi-backburger')
    })
})


/* NavBar menu mobile toggle */

Array.from(document.getElementsByClassName('--pb-navbar-menu-toggle')).forEach(el => {
    el.addEventListener('click', e => {
      const dropdownIcon = e.currentTarget
          .getElementsByClassName('icon')[0]
          .getElementsByClassName('fa-solid')[0]
  
      document.getElementById(e.currentTarget.getAttribute('data-target')).classList.toggle('active')
      dropdownIcon.classList.toggle('fa-bars')
      dropdownIcon.classList.toggle('fa-xmark')
    })
})
Array.from(document.getElementsByClassName('--pb-navbar-menu-open')).forEach(el => {
    el.addEventListener('click', e => {
      const dropdownIcon = e.currentTarget
          .getElementsByClassName('icon')[0]
          .getElementsByClassName('fa-solid')[0]
  
      document.getElementById(e.currentTarget.getAttribute('data-target')).classList.toggle('active')
    })
})
Array.from(document.getElementsByClassName('--pb-navbar-menu-close')).forEach(el => {
    el.addEventListener('click', e => {
      const dropdownIcon = e.currentTarget
          .getElementsByClassName('icon')[0]
          .getElementsByClassName('fa-solid')[0]
  
      document.getElementById(e.currentTarget.getAttribute('data-target')).classList.toggle('active')
    })
})

  // =======================================================
  //                 ATTACH OTHER EVENT LISTENERS
  // =======================================================

function AttachOtherEventListeners () {


  document.querySelectorAll('.combo-offer-ebook-select').forEach(item => {
    item.addEventListener('change', comboOfferEbookSelected);
  });

  // Add Event Listener to Claim combo offer button
  document.querySelectorAll('.claim-combo-offer').forEach(item => {
    item.addEventListener('click', claimComboOfferClicked);
  });
}

